const STORAGE_KEY = 'wand:theme';
type Theme = 'dark' | 'light';

let theme = $state<Theme>('dark');

export function initTheme() {
  const saved = localStorage.getItem(STORAGE_KEY) as Theme | null;
  theme = saved === 'light' ? 'light' : 'dark';
  applyTheme();
}

function applyTheme() {
  if (theme === 'light') {
    document.documentElement.setAttribute('data-theme', 'light');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
}

export function toggleTheme() {
  theme = theme === 'dark' ? 'light' : 'dark';
  localStorage.setItem(STORAGE_KEY, theme);
  applyTheme();
}

export function getTheme(): Theme {
  return theme;
}
